import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inbound_order_details_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectId?: number, warehouseId?: number[], fromDate?: string, toDate?: string, orderIds?: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualTargetLicensePlateId?: number, CompletedDateTime?: string, GrossWeight?: number, NetWeight?: number, Order?: { LookupCode?: string, OwnerReference?: string, Project?: { LookupCode?: string }, Account?: { Id?: number, Name?: string } }, Shipment?: { ShippedDate?: string }, ActualTargetLicensePlate?: { Id?: number, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Location?: { Name?: string }, Status?: { Name?: string } }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, Material?: { Id?: number, Description?: string, IsFixedWeight?: boolean, LookupCode?: string, PackagingLookups?: { ShippingWeight?: number, Weight?: number }[] } }, ActualPackagedPack?: { Id?: number, Name?: string, ShortName?: string }, material_packaging_weights?: { MaterialId?: number, PackagingId?: number, ShippingWeight?: number, Weight?: number }[], First_ShippingWeight?: number, First_Weight?: number }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { projectId?: number, warehouseId?: number[], fromDate?: string, toDate?: string, orderIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualTargetLicensePlateId?: number, CompletedDateTime?: string, GrossWeight?: number, NetWeight?: number, Order?: { LookupCode?: string, OwnerReference?: string, Project?: { LookupCode?: string }, Account?: { Id?: number, Name?: string } }, Shipment?: { ShippedDate?: string }, ActualTargetLicensePlate?: { Id?: number, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Location?: { Name?: string }, Status?: { Name?: string } }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, Material?: { Id?: number, Description?: string, IsFixedWeight?: boolean, LookupCode?: string, PackagingLookups?: { ShippingWeight?: number, Weight?: number }[] } }, ActualPackagedPack?: { Id?: number, Name?: string, ShortName?: string }, material_packaging_weights?: { MaterialId?: number, PackagingId?: number, ShippingWeight?: number, Weight?: number }[], First_ShippingWeight?: number, First_Weight?: number }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { projectId?: number, warehouseId?: number[], fromDate?: string, toDate?: string, orderIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualTargetLicensePlateId?: number, CompletedDateTime?: string, GrossWeight?: number, NetWeight?: number, Order?: { LookupCode?: string, OwnerReference?: string, Project?: { LookupCode?: string }, Account?: { Id?: number, Name?: string } }, Shipment?: { ShippedDate?: string }, ActualTargetLicensePlate?: { Id?: number, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Location?: { Name?: string }, Status?: { Name?: string } }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string, Material?: { Id?: number, Description?: string, IsFixedWeight?: boolean, LookupCode?: string, PackagingLookups?: { ShippingWeight?: number, Weight?: number }[] } }, ActualPackagedPack?: { Id?: number, Name?: string, ShortName?: string }, material_packaging_weights?: { MaterialId?: number, PackagingId?: number, ShippingWeight?: number, Weight?: number }[], First_ShippingWeight?: number, First_Weight?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectId?: number, warehouseId?: number[], fromDate?: string, toDate?: string, orderIds?: number[]    }) {
      return false;
    }
}
